/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';

export interface UpdateAdverseMediaEntitiesListRequest {
    source: UpdateAdverseMediaEntitiesListSourceEnum;
}

/**
 * 
 */
export class AdverseMediaEntityListApi extends runtime.BaseAPI {

    /**
     * Updates adverse media entities list
     */
    async updateAdverseMediaEntitiesListRaw(requestParameters: UpdateAdverseMediaEntitiesListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.source === null || requestParameters.source === undefined) {
            throw new runtime.RequiredError('source','Required parameter requestParameters.source was null or undefined when calling updateAdverseMediaEntitiesList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/lists/adverse-media-entity/{source}`.replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates adverse media entities list
     */
    async updateAdverseMediaEntitiesList(requestParameters: UpdateAdverseMediaEntitiesListRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateAdverseMediaEntitiesListRaw(requestParameters, initOverrides);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum UpdateAdverseMediaEntitiesListSourceEnum {
    DOWJONES = 'DOWJONES'
}
